import { Directive } from '@angular/core';

@Directive({
  selector: '[appFilterTabContent]'
})
export class FilterTabContentDirective { }
